<p-confirmDialog></p-confirmDialog>

<div class="flex shadow">
  <div class="grow p-4 pos-relative edit-button" (click)="navigateToEdit()" role="button"
    aria-roledescription="Bearbeite diesen Eintrag">
    <div class="grid grid-cols-4 gap-4">

      <div class="col-span-4 sm:col-span-2 md:col-span-1 flex my-auto items-center justify-center">
        <div class="flex gap-2 items-center">
          @if (rabbit().isDisabled) {
            <ng-icon name="gameSightDisabled" />
          }
          <ng-icon name="simpleVowpalwabbit" />
          <div>{{ rabbit().name }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="bg-red-500 text-white text-center flex flex-col justify-center">
    <button type="button" title="Löschen" class="reset cursor-pointer primary-color-text p-4 h-full"
      (click)="confirmDeleteRabbit()">
      <ng-icon name="matDeleteSharp"></ng-icon>
    </button>
  </div>
</div>